"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-cycle, camelcase */
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var customLessonsApi_1 = require("../mock/customLessonsApi");
var CustomLessonsAPIs = {
    fetchLinkedCourses: function (uuid) {
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.fetchLinkedCourses,
            url: (0, combinePlatformUrl_1.default)("/api/v2/content-management/lessons/".concat(uuid, "/linked-courses")),
        });
    },
    getAllCustomLessons: function (isLink) {
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.getAllCustomLessons,
            url: (0, combinePlatformUrl_1.default)("/api/v2/content-management/lessons?linked=".concat(isLink)),
        });
    },
    validateBeforeDeleteCustomLesson: function (uuid) {
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.validateBeforeDeleteCustomLesson,
            url: (0, combinePlatformUrl_1.default)("/api/v2/content-management/lessons/".concat(uuid, "/verify-before-delete")),
        });
    },
    deleteCustomLesson: function (uuid) {
        return fetchApi_1.default.delete({
            mockFunc: customLessonsApi_1.deleteCustomLesson,
            url: (0, combinePlatformUrl_1.default)("/api/v2/content-management/lessons/".concat(uuid)),
        });
    },
};
exports.default = CustomLessonsAPIs;
